import React from 'react';
import s from 'styled-components';
import cn from 'classnames';

const Styles = ({
  $display,
  $direction,
  $m,
  $p,
  $ai,
  $self,
  $jc,
  $height,
  $flex,
  theme,
  $br,
  $gap,
  $bg,
  $width,
  $pointer,
  $textAlign,
  $jcs,
  $ac,
  $shrink,
  $maxWidth,
}) => `
  height: ${$height || 'auto'};
  display: ${$display || 'flex'};
  gap: ${$gap || ''};
  max-width: ${$maxWidth};
  width: ${$width || 'auto'};
  flex-direction: ${$direction || 'row'};
  align-items: ${$ai || ''};
  align-content: ${$ac || ''};
  align-self: ${$self || ''};
  justify-content: ${$jc || 'flex-start'};
  justify-self: ${$jcs || 'unset'};
  margin: ${$m || 'unset'};
  padding: ${$p || 'unset'};
  flex: ${$flex ? `${$flex} !important` : ''};
  flex-shrink: ${$shrink || ''};
  background-color: ${theme.colors[$bg] || $bg || ''};
  border-radius: ${theme.radius[$br] || $br || '0'};
  cursor: ${$pointer ? 'pointer' : ''};
  ${$textAlign ? `text-align: ${$textAlign};` : ''}
`;

const BoxContainerDiv = s.div`
  ${(props) => Styles(props)}
`;

const BoxContainerSpan = s.span`
  ${(props) => Styles(props)}
`;

const BoxContainerLabel = s.label`
  ${(props) => Styles(props)}
`;

const Box = ({
  children = null,
  as = null,
  className = '',
  br = 'unset',
  bg,
  maxWidth = '',
  display,
  direction,
  m,
  p,
  ai,
  ac,
  self,
  gap,
  jc,
  jcs,
  height,
  flex,
  width,
  shrink,
  pointer,
  textAlign,
  ...otherProps
}) => {
  const classes = cn('w-box', className);
  const props = {
    $br: br,
    $shrink: shrink,
    $bg: bg,
    $gap: gap,
    className: classes,
    $maxWidth: maxWidth,
    $display: display,
    $direction: direction,
    $m: m,
    $p: p,
    $ai: ai,
    $ac: ac,
    $self: self,
    $jc: jc,
    $height: height,
    $flex: flex,
    $width: width,
    $pointer: pointer,
    $textAlign: textAlign,
    $jcs: jcs,
    ...otherProps,
  };

  if (as === 'span') {
    return <BoxContainerSpan {...props}>{children}</BoxContainerSpan>;
  } if (as === 'label') {
    return <BoxContainerLabel {...props}>{children}</BoxContainerLabel>;
  }

  return <BoxContainerDiv {...props}>{children}</BoxContainerDiv>;
};

export default Box;
